import React, { useState } from 'react';
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Toolbar,
  Typography,
  Tooltip
} from '@mui/material';


import { useNavigate } from "react-router-dom";

import DashboardIcon from '@mui/icons-material/Dashboard';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import DescriptionIcon from '@mui/icons-material/Description';
import {
  AccountCircle
} from "@mui/icons-material";

const drawerWidth = 240;
const collapsedWidth = 72;
type PatientSidebarProps = {
    collapsed: boolean;
  };
export default function PatientSidebar({ collapsed }: PatientSidebarProps) {
  const navigate = useNavigate();

  return (
      <Drawer
        variant="permanent"
        sx={{
          width: collapsed ? collapsedWidth : drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: collapsed ? collapsedWidth : drawerWidth,
            boxSizing: 'border-box',
            transition: 'width 0.3s ease',
            backgroundColor: '#002244',
            color: '#fff',
          },
        }}
      >
        <Toolbar />
        <Divider />
        <List>
          {[
            { id: 1, text: 'Dashboard', icon: <Tooltip title="Dashbaord" arrow><DashboardIcon /></Tooltip>, route:"/patient-dashboard" },
            { id: 2, text: 'My Test(s)', icon: <Tooltip title="My Test(s)" arrow><LocalHospitalIcon /></Tooltip>, route:"/patient/tests" },
            { id: 3, text: 'My Report(s)', icon: <Tooltip title="My Report(s)" arrow><DescriptionIcon /></Tooltip>, route:"/patient/reports" },
            { id: 4, text: 'My Profile', icon: <Tooltip title="My Profile" arrow><AccountCircle /></Tooltip>, route:"/patient/profile" }
          ].map(({ id, text, icon, route }) => (
            <ListItem key={id} disablePadding sx={{ display: 'block' }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: collapsed ? 'center' : 'initial',
                  px: 2.5,
                }}
                onClick={() => navigate(route)}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: collapsed ? 'auto' : 3,
                    justifyContent: 'center',
                    color: 'inherit',
                  }}
                >
                  {icon}
                </ListItemIcon>
                {!collapsed && (
                  <Typography variant="body1" sx={{ color: 'white' }}>
                    {text}
                  </Typography>
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
  );
}
